import { standardCachingQueryOptions } from 'pos-client/utils/standardCachingQueryOptions.ts';
import { trpc } from 'pos-client/utils/trpc.ts';
import type { OrderIdModel } from 'pos-shared/models/orderSchema.ts';

export const useOrderPayments = ({ orderId }: OrderIdModel) => {
  const {
    data: orderPayments,
    isLoading: isLoadingOrderPayments,
    isFetching: isFetchingOrderPayments,
    ...rest
  } = trpc.orders.getOrderPayments.useQuery(
    {
      orderId,
    },
    {
      ...standardCachingQueryOptions,
      enabled: !!orderId,
    }
  );

  return {
    orderPayments,
    isLoadingOrderPayments,
    isFetchingOrderPayments,
    ...rest,
  };
};
